import { SCREEN_BREAKPOINTS } from 'root/widgets/constants';

export const isValidEmail = (input: string): boolean => {
  const re = /\S+@\S+\.\S+/;
  return re.test(input);
};

export const isInteger = (input: string): boolean => {
  const re = /^-?\d+$/;
  return re.test(input);
};

export const validateDependencies = (dependencies: Record<string, any>, expectedDependencies: Array<string> = []) => {
  expectedDependencies.forEach((expectedDependency) => {
    if (!dependencies[expectedDependency]) {
      throw new Error(`Expected dependency not provided: ${expectedDependency}`);
    }
  });

  return true;
};

export const isBrowser = (): boolean => typeof window !== 'undefined';

export const isMobile = () => isBrowser() && window.innerWidth < SCREEN_BREAKPOINTS.SM;

export const isTablet = () => isBrowser() && window.innerWidth < SCREEN_BREAKPOINTS.LG;

export const isDesktop = () => isBrowser() && window.innerWidth >= SCREEN_BREAKPOINTS.LG;

export default {};
